import { SeasonsComponent } from './user-content/seasons/seasons.component';
import { SeasonScoreDialogComponent } from './user-content/seasons/season-score-dialog.component';
import { SeasonRewardsDialogComponent } from './user-content/seasons/season-rewards-dialog.component';
import { RafflesComponent } from './user-content/raffles/raffles.component';
import { RaffleRelationsDialogComponent } from './user-content/raffles/raffle-relations-dialog.component';
import { RaffleEditDialogComponent } from './user-content/raffles/raffle-edit-dialog.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonStatsComponent} from './user-content/common-stats/common-stats.component';
import {OperationsLogComponent} from './user-content/operations-log/operations-log.component';
import {RefillComponent} from './user-content/refill/refill.component';
import {WithdrawComponent} from './user-content/withdraw/withdraw.component';
import {SearchUserRoutingModule} from "./search-user-routing.module";
import {SearchUserComponent} from "./search-user.component";
import {SharedModule} from "../../@shared/shared.module";
import {UserContentComponent} from './user-content/user-content.component';
import {FindComponent} from './find/find.component';
import {CheckIpComponent} from "./check/check-ip/check-ip.component";
import {CheckWalletComponent} from "./check/check-wallet/check-wallet.component";
import {InventoryLogComponent} from "./user-content/inventory-log/inventory-log.component";
import {ReferralCampaignsComponent} from './user-content/referral-campaigns/referral-campaigns.component';
import {
  ReferralDetailsComponent
} from './user-content/referral-campaigns/modals/referral-details/referral-details.component';
import {AddBalanceComponent} from './modals/add-balance/add-balance.component';
import {InventoryItemComponent} from './user-content/inventory-log/inventory-item/inventory-item.component';
import {DetailsComponent} from "./user-content/inventory-log/modals/details/details.component";
import {UserInventoryComponent} from './user-content/user-inventory/user-inventory.component';
import {ItemComponent} from './user-content/user-inventory/item/item.component';
import {AuthHistoryComponent} from './modals/auth-history/auth-history.component';
import {OperationDetailsComponent} from "./user-content/operations-log/modals/details/operation-details.component";
import {CashbackHistoryComponent} from './user-content/cashback-history/cashback-history.component';
import {DateFilterModule} from "../../@shared/date-filter/date-filter.module";
import {XpHistoryComponent} from './user-content/xp-history/xp-history.component';
import {UserCashbackHistoryService} from "./user-content/services/user-cashback-history.service";
import {UserXpHistoryService} from "./user-content/services/user-xp-history.service";
import {RefIncomeLogComponent} from './user-content/referral-campaigns/ref-income-log/ref-income-log.component';
import {MarketComponent} from './user-content/market/market.component';
import {BidsComponent} from './user-content/market/bids/bids.component';
import {MarketService} from "./user-content/services/market/market.service";
import { SteamInventoryComponent } from './user-content/market/steam-inventory/steam-inventory.component';
import { RefillItemsComponent } from './user-content/market/refill-items/refill-items.component';
import { MarketItemComponent } from './user-content/market/market-item/market-item.component';
import {ScrollToDirective} from "../../@core/directives/scrollTo";
import { ReferralInfoComponent } from './modals/referral-info/referral-info.component';
import { FreeCasesComponent } from './user-content/free-cases/free-cases.component';
import { ResetReferralIncomeComponent } from './user-content/referral-campaigns/modals/reset-referral-income/reset-referral-income.component';
import { UserHeaderComponent } from './user-content/user-header/user-header.component';
import { RestrictionsComponent } from './user-content/restrictions/restrictions.component';
import { AddFreeUserCasesComponent } from './user-content/free-cases/modals/add-free-user-cases/add-free-user-cases.component';
import { WithdrawLimitModalComponent } from './user-content/restrictions/modals/withdraw-limit-modal/withdraw-limit-modal.component';
import { LockModalComponent } from './user-content/restrictions/modals/lock-modal/lock-modal.component';
import { LockHistoryModalComponent } from './user-content/restrictions/modals/lock-history-modal/lock-history-modal.component';
import { WelcomeCasesComponent } from './user-content/welcome-cases/welcome-cases.component';
import { CheckUserSteamComponent } from './user-content/market/check-user-steam/check-user-steam.component';
import { BalanceHistoryComponent } from './user-content/balance-history/balance-history.component';
import { PromoCodesHistoryComponent } from './user-content/promo-codes-history/promo-codes-history.component';
import { PromoInfoModalComponent } from './user-content/promo-codes-history/promo-info-modal/promo-info-modal.component';
import { ManualPromoActivationDialogComponent } from './user-content/promo-codes-history/manual-promo-activation-dialog/manual-promo-activation-dialog.component';
import {HighlightAmountDirective} from "../../@core/directives/highlight-amount.directive";
import { PaybacksComponent } from './user-content/paybacks/paybacks.component';
import { PaybackDialogComponent } from './user-content/paybacks/payback-dialog/payback-dialog.component';
import { PaybackWalletDialogComponent } from './user-content/paybacks/payback-wallet-dialog/payback-wallet-dialog.component';
import { PayoutLockSettingsComponent } from './user-content/restrictions/modals/payout-lock-settings/payout-lock-settings.component';
import {AccessDirective} from "../../@core/directives/access.directive";
import {VipComponent} from './user-content/vip/vip.component';
import {MatDialogModule} from '@angular/material/dialog';
import {UserCustomizationComponent} from './user-content/customization/user-customization.component';
import {ContactsComponent} from './user-content/contacts/contacts.component';

@NgModule({
  declarations: [
    CommonStatsComponent,
    SearchUserComponent,
    OperationsLogComponent,
    InventoryLogComponent,
    RefillComponent,
    WithdrawComponent,
    UserContentComponent,
    FindComponent,
    CheckIpComponent,
    CheckWalletComponent,
    ReferralCampaignsComponent,
    ReferralDetailsComponent,
    AddBalanceComponent,
    InventoryItemComponent,
    DetailsComponent,
    UserInventoryComponent,
    ItemComponent,
    AuthHistoryComponent,
    OperationDetailsComponent,
    CashbackHistoryComponent,
    XpHistoryComponent,
    RefIncomeLogComponent,
    MarketComponent,
    BidsComponent,
    SteamInventoryComponent,
    RefillItemsComponent,
    MarketItemComponent,
    ScrollToDirective,
    ReferralInfoComponent,
    FreeCasesComponent,
    ResetReferralIncomeComponent,
    UserHeaderComponent,
    RestrictionsComponent,
    AddFreeUserCasesComponent,
    WithdrawLimitModalComponent,
    LockModalComponent,
    LockHistoryModalComponent,
    WelcomeCasesComponent,
    CheckUserSteamComponent,
    BalanceHistoryComponent,
    PromoCodesHistoryComponent,
    SeasonsComponent,
    SeasonScoreDialogComponent,
    SeasonRewardsDialogComponent,
    RafflesComponent,
    RaffleRelationsDialogComponent,
    RaffleEditDialogComponent,
    PromoInfoModalComponent,
    ManualPromoActivationDialogComponent,
    PaybacksComponent,
    PaybackDialogComponent,
    PaybackWalletDialogComponent,
    PayoutLockSettingsComponent,
    VipComponent,
    UserCustomizationComponent,
    ContactsComponent
  ],
  exports: [],
    imports: [
        CommonModule,
        SearchUserRoutingModule,
        SharedModule,
        DateFilterModule,
        MatDialogModule,
        HighlightAmountDirective,
        AccessDirective
    ],
  providers: [
    UserCashbackHistoryService,
    UserXpHistoryService,
    MarketService
  ]
})
export class SearchUserModule {
}
